import React, { PureComponent } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import MediaQuery from 'react-responsive'
import WantedTabs from '../../common/WantedTabs'
import breakpoints from '../../styles/breakpoints'
import WantedItems from './WantedItems'
import InterestItems from './InterestItems'
import withTopBar from '../../common/TopBar/withTopBar'

class Wanted extends PureComponent {
  render() {
    const { match } = this.props

    return (
      <div>
        <MediaQuery minWidth={breakpoints.sm}>
          <Route
            path={`${match.path}/:type?`}
            render={({ match }) => <WantedTabs type={match.params.type} />}
          />
        </MediaQuery>

        <div className="WantedItemsPage">
          <Switch>
            <Route path={`${match.path}`} exact component={WantedItems} />
            <Route
              path={`${match.path}/interessi`}
              exact
              component={InterestItems}
            />
            <Redirect to={`${match.path}`} />
          </Switch>
        </div>

        <MediaQuery maxWidth={breakpoints.sm}>
          <Route
            path={`${match.path}/:type?`}
            render={({ match }) => <WantedTabs type={match.params.type} />}
          />
        </MediaQuery>
      </div>
    )
  }
}

export default withTopBar({
  title: 'Lista voglio',
  toolbar: 'ItemsToolbar',
})(Wanted)



// WEBPACK FOOTER //
// ./src/pages/Me/Wanted.js